@if (formGroup) {
  <app-input-control
    [fg]="formGroup"
    [formGroupOrControlName]="formGroupOrControlName"
    [label]="label"
    [autocomplete]="autocomplete"
    type="password"
  ></app-input-control>
}
